import GateAssignmentContainer from "../../../Component/Application/GateAssignment/GateAssignmentContainer";

const GateAssignmentPage = () => {
    return (
        <div className="page-body">
            <GateAssignmentContainer />
        </div>
    );
};

export default GateAssignmentPage;